import * as $ from "jquery";
import * as _ from "lodash";
import {ModuleLayoutCollection} from "../../collections/ModuleLayout";
import {PermissionCollection} from "../../collections/Permissions";
import {ModuleCollection} from "../../collections/Modules";
import {SensorConfigCollection} from "../../collections/SensorConfigs";
import {SensorStatus} from "../../common/SensorStatus"
import {ModifyLayoutModal} from "../modals/ModifyLayoutModal";
import {BaseSettingsView, BaseSettingsViewOptions} from "./_BaseSettingsView";
import {AppRegistry} from "../../apps/AppRegistry";
import {AppCollection} from "../../collections/Apps";
import {DashboardCollection} from "../../collections/Dashboards";
import {BrandCollection} from "../../collections/Brands";
import {GenericDeleteModal} from "../modals/GenericDeleteModal";
const Backbone = require("backbone");
const Draggabilly = require('draggabilly');

var template = require('templates/settings/installationLayout.html');

export interface InstallationLayoutViewOptions extends BaseSettingsViewOptions {
    appRegistry: AppRegistry;
    appCollection: AppCollection;
    dashboardCollection: DashboardCollection;
    brandCollection: BrandCollection
}

export class InstallationLayoutView extends BaseSettingsView {

    template = _.template(template);
    moduleDotTemplate = _.template(require('templates/settings/moduleLayoutDot.html'));
    ModuleLayoutCollection: ModuleLayoutCollection;
    PermissionCollection: PermissionCollection;
    ModuleCollection: ModuleCollection;
    private currentInstallId: number;
    private currentFloor;
    private orderedFloors;
    private renderedModuleIds;
    options: InstallationLayoutViewOptions;

    constructor(options: InstallationLayoutViewOptions) {
        super(<any>_.extend(options, {
            el: '#settings-main-subview',
            events: {
                'click .update-floor': 'handleUpdateLayout',
                'click .add': 'handleAddLayout',
                'click .delete-floor': 'handleDeleteLayout',
                'click .previous-floor': 'handlePrevFloor',
                'click .next-floor': 'handleNextFloor',
                'click .layout-module-item': 'handleAddModuleToSvg',
                'click .toggleSelectedModules': 'toggleSelectedModules',
                'input #module-layout-filter-input': 'moduleFilterChange'
            }
        }));
        this.currentInstallId = options.installId;
        this.ModuleLayoutCollection = new ModuleLayoutCollection([], options.installId);
        this.PermissionCollection = new PermissionCollection();
        this.ModuleCollection = new ModuleCollection([], { installId: this.currentInstallId });
        this.moduleFilterChange = _.debounce(this.moduleFilterChange, 300);
        this.renderedModuleIds = [];
    }

    private moduleFilterChange() {
        var lis = $('.layout-module-item').get();
        var filter = (<string>this.$('#module-layout-filter-input').val()).toLowerCase();
        var toggled = $('.toggleSelectedModules').data('toggled')
        lis.reverse();

        _.each(lis, (li) => {
            var number = $(li).data('module-number').toString();
            var location = $(li).data('module-location').toLowerCase();
            if ((location.indexOf(filter) !== -1 || number.indexOf(filter) !== -1)) {
                $(li).removeClass('hidden');
            } else {
                $(li).addClass('hidden');
            }
        });

        if(toggled){
            $('.toggleSelectedModules').data('toggled',!toggled)
            this.toggleSelectedModules()
        }
    }

    toggleSelectedModules() {
        var toggled = $('.toggleSelectedModules').data('toggled');
        var moduleList = $('.layout-module-item');
        _.each(moduleList, function (item) {
            if (toggled) {
                if ($(item).data('added-module')) {
                    $(item).removeClass('hidden');
                }
            } else {
                if ($(item).data('added-module')) {
                    $(item).addClass('hidden');
                }
            }
        });
        if (toggled) {
            $('.toggleSelectedModules').addClass('fa-eye');
            $('.toggleSelectedModules').removeClass('fa-eye-slash');
        } else {
            $('.toggleSelectedModules').addClass('fa-eye-slash');
            $('.toggleSelectedModules').removeClass('fa-eye');

        }
        $('.toggleSelectedModules').data('toggled',!toggled)
    }

    handlePrevFloor() {
        var currentFloor = this.currentFloor;
        var paginated = false;
        _.each(this.orderedFloors.reverse(), function (layout) {
            if (currentFloor.get('order') > layout.get('order') && !paginated) {
                $('#layout-drag-svg-modules-container-' + layout.get('id')).removeAttr('hidden')
                $('#layout-drag-svg-modules-container-' + currentFloor.get('id')).attr('hidden', '')
                currentFloor = layout;
                $('#floor-title').text(currentFloor.get('name'));
                paginated = true;
            }
        })
        if (paginated) {
            this.currentFloor = currentFloor;
        }
        this.orderedFloors.reverse();
    }

    handleNextFloor() {
        var currentFloor = this.currentFloor;
        var paginated = false;
        _.each(this.orderedFloors, function (layout) {
            if (layout.get('order') > currentFloor.get('order') && !paginated) {
                $('#layout-drag-svg-modules-container-' + layout.get('id')).removeAttr('hidden')
                $('#layout-drag-svg-modules-container-' + currentFloor.get('id')).attr('hidden', '')
                currentFloor = layout;
                $('#floor-title').text(currentFloor.get('name'));
                paginated = true;
            }
        })
        this.currentFloor = currentFloor;
    }

    handleUpdateLayout() {
        var layoutId = this.currentFloor.get('id');
        var layoutOrder = this.currentFloor.get('order');
        var layoutName = this.currentFloor.get('name');

        var modal = new ModifyLayoutModal(_.extend({}, this.options, {
            installId: this.currentInstallId,
            modelId: layoutId,
            order: layoutOrder,
            name: layoutName,
            action: "update",
        }));

        $('.modals').append(modal.render().el);
        modal.show();
        modal.renderDropzone();
        modal.showLoadedFiles(this.ModuleLayoutCollection.findWhere({ id: layoutId }));
        $('.save-layouts-btn').removeAttr('disabled');
    }

    handleAddLayout() {
        var modal = new ModifyLayoutModal(_.extend({}, this.options, {
            installId: this.currentInstallId,
            modelId: null,
            order: 0,
            name: '',
            action: "insert",
        }));
        $('.modals').append(modal.render().el);
        modal.show();
        modal.renderDropzone();
    }

    handleDeleteLayout() {
        var layoutId = this.currentFloor.get('id');
        var layoutName = this.currentFloor.get('name');

        var file = this.ModuleLayoutCollection.findWhere({ id: layoutId })

        var modal = new GenericDeleteModal({
            type: 'File',
            name: layoutName,
            func: () => {
                return $.when(file.destroy()).done(() => {
                    Backbone.history.loadUrl()
                });
            },
            warning: "Warning: This action will permanently delete the file."
        });
        $('.modals').append(modal.render().el);
        modal.show();
    }

    private ensureCollectionsLoaded() {
        var outerDeferred = $.Deferred();
        $.when(
            this.ModuleCollection.getCollectionFetchPromise(),
            this.ModuleLayoutCollection.getCollectionFetchPromise()
        ).then(() => {
            outerDeferred.resolve();
        });
        return outerDeferred;
    }

    render() {
        this.renderLayoutList(false)
        $.when(this.ensureCollectionsLoaded())
            .then(() => {
                this.renderLayoutList(true)
            })
            .done(() => {
                $(window).off("resize");
                $(window).resize(() => {
                    this.resizeHandler();
                });

                // Sometimes the dots do not render on the layout, probably due to the ordr of operations
                // As a temporary fix we can trigger the window resize which redraws the layout svg dots to ensure
                // they show after everything else loaded
                $(() => { //shorthand for $(document).ready(fn)
                    window.dispatchEvent(new UIEvent('resize'));
                });
            })

        return this;
    }


    resizeHandler(){
        var currentFloor = this.currentFloor;

        _.each(this.orderedFloors, (layout) => {
            $('#layout-drag-svg-modules-container-' + layout.get('id')).removeAttr('hidden')
            var coordinates = JSON.parse(layout.get('module_ui_positions'))
            var me = this;

            _.each(coordinates, (coordinate) => {
                var module = me.ModuleCollection.findWhere({ module_id: Number(coordinate.id) });
                if (!module) return;
                var imageId = '#wd-img-modules-container-' + layout.get('id') ;
                var resizeCoordinates = this.getScreenWidth(coordinate, imageId);

                $('#svg-drag-module-' + module.get('module_id')).css({
                    'width': resizeCoordinates.width,
                    'height': resizeCoordinates.height,
                    'left': resizeCoordinates.left,
                    'top': resizeCoordinates.top
                })
            })

            if (currentFloor.get('id') != layout.get('id')) {
                $('#layout-drag-svg-modules-container-' + layout.get('id')).attr('hidden', '')
            }
        })
    }



    renderLayoutList(collectionLoaded) {
        if (collectionLoaded) {
            _.each(this.ModuleCollection.models, function (modulo) {
                var sensorConfigCollection = new SensorConfigCollection([], { moduleId: modulo.get('module_id') });
                _.extend(modulo, {
                    status: new SensorStatus({
                        sensorConfigCollection: sensorConfigCollection,
                        moduleModel: modulo
                    })
                })
            })
            var layouts = this.ModuleLayoutCollection.where({ install_id: this.options.installId })
            layouts.sort((a, b) => (a.attributes.order ?? Infinity) - (b.attributes.order ?? Infinity));
            this.currentFloor = layouts[0];
            this.orderedFloors = layouts;
        }

        this.setUnrenderedModuleIds();

        this.$el.html(this.template({
            layoutCollection: this.ModuleLayoutCollection,
            moduleCollection: this.ModuleCollection,
            collectionLoaded: collectionLoaded,
            sortedLayoutCollection: layouts,
            currentInstallId: this.currentInstallId,
            permissionCollection: this.options.permissionCollection,
        }));
        this.renderModules(collectionLoaded);

    }

    dragEndHandler(me, event, pointer) {
        var dropZonePosition = $('.square-dropzone').position();
        var item = $('#' + pointer.target.id).position();
        var deleted = false;
        var targetId = $(pointer.target).data('moduleId');
        var targetNumber = $(pointer.target).data('moduleLocation');
        if (dropZonePosition.top < item.top) {
            $('#' + pointer.target.id).remove();
            deleted = true;
        }

        var buildPositionArray = me.buildPositionArray
        var layouts = me.ModuleLayoutCollection.where({ install_id: me.options.installId })
        var floorId = '#layout-drag-svg-modules-container-' + me.currentFloor.get('id');

        var notification = (<any>$).notify({
            icon: 'fa fa-info-circle',
            title: "Saving position of module <i>" + _.escape(targetNumber) + "</i>",
            message: ""
        }, {delay: 0, offset: {x: 20, y: 60}});

        _.each(layouts, function (layout) {
            var svgFiles = $('#layout-drag-svg-modules-container-' + layout.get('id') + ' > div')
            var data = []
            if (svgFiles.length) {
                data = buildPositionArray(svgFiles, me.currentFloor)
            }
            var obj = [{
                name: layout.get('name'),
                order: layout.get('order'),
                install_id: layout.get('install_id'),
                module_ui_positions: JSON.stringify(data),
                layout_image: layout.get('layout_image')
            }]
            $.ajax({
                type: 'PUT',
                url: window.location.origin + '/api/v1/installs/' + me.currentInstallId + '/layout/' + layout.get('id'),
                data: JSON.stringify(obj),
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                success: () => {
                    if (deleted) {
                        $('*[data-module-id="' + targetId + '"].layout-module-item ').data("added-module", false)
                        $('*[data-module-id="' + targetId + '"].layout-module-item ').removeAttr('style')
                        $('#floorLocation-'+ targetId).empty();
                    }

                    notification.update('title','New position of module <i>' + _.escape(targetNumber) + '</i> has been saved');
                    setTimeout(function() {
                        notification.close();
                    }, 2000);

                }
            });
        })
    }

    private setUnrenderedModuleIds() {
        _.each(this.ModuleLayoutCollection.models, (layout) => {
            var coordinates = JSON.parse(layout.get('module_ui_positions'))
            var me = this;
            _.each(coordinates, (coordinate) => {
                this.renderedModuleIds.push({ module_id: Number(coordinate.id) });
            });
        });
    }

    private setDraggable(floorId, id) {
        var me = this;
        var draggables = $('#svg-drag-module-' + id)
        var dragEndHandler = _.debounce(this.dragEndHandler, 300)

        _.each(draggables, function (draggable) {
            var draggie = <any>new Draggabilly(draggable, {
                containment: '#layout-drag-svg-container'
            })

            draggie.on('dragEnd', function (event, pointer) {
                dragEndHandler(me, event, pointer)
            })
        })
    }


    handleAddModuleToSvg(e: JQuery.UIEventBase) {
        var added = $(e.currentTarget).data('added-module')
        if (!added) {
            var number = $(e.currentTarget).data('module-number');
            var location = $(e.currentTarget).data('module-location');
            var id = $(e.currentTarget).data('module-id');
            var floorId = '#layout-drag-svg-modules-container-' + this.currentFloor.get('id');
            var sensorConfigCollection
            var moduleStatus;
            var colorStatus;
            var currentModule;
            _.each(this.ModuleCollection.models, function (module) {
                if (module.get('module_number') == number) {
                    currentModule = module;
                    var sensorStatus = new SensorStatus({
                        sensorConfigCollection: sensorConfigCollection,
                        moduleModel: module
                    });
                    moduleStatus = sensorStatus.getCombinedStatus(null, 0);

                    switch (moduleStatus.status) {
                        case 'danger':
                            colorStatus = '#D61F26'
                            break;
                        case 'warning':
                            colorStatus = '#FFC04F'
                            break;
                        default:
                            colorStatus = '#4CB975'
                            break;
                    }
                }
            })

            $(floorId).append(this.moduleDotTemplate({
                module: currentModule,
                moduleStatus: moduleStatus,
                coordinate: {x:0,y:0},
                colorStatus: colorStatus,
                layout: this.currentFloor
            }))

            this.setDraggable(floorId, id);

            $(e.currentTarget).data('added-module', true)
            // $(e.currentTarget).addClass('hidden');
            $(e.currentTarget).css({ 'background-color': '#F8F8F8', 'cursor': 'not-allowed', 'opacity': '.6' })
            $('#floorLocation-' + $(e.currentTarget).data('module-id')).append('Floor: ' + _.escape(this.currentFloor.get('name')))
        }

    }

    renderModules(collectionLoaded) {
        if (!collectionLoaded) return;

        _.each(this.ModuleLayoutCollection.models, (layout) => {
            var coordinates = JSON.parse(layout.get('module_ui_positions'))
            var sensorConfigCollection
            var moduleStatus;
            var me = this;

            _.each(coordinates, (coordinate) => {
                var module = me.ModuleCollection.findWhere({ module_id: Number(coordinate.id) })
                if (!module) return;
                var floorId = '#layout-drag-svg-modules-container-' + layout.get('id');
                var colorStatus = '';


                var sensorStatus = new SensorStatus({
                    sensorConfigCollection: sensorConfigCollection,
                    moduleModel: module
                });
                moduleStatus = sensorStatus.getCombinedStatus(null, 0);

                switch (moduleStatus.status) {
                    case 'danger':
                        colorStatus = '#D61F26'
                        break;
                    case 'warning':
                        colorStatus = '#FFC04F'
                        break;
                    default:
                        colorStatus = '#4CB975'
                        break;
                }

                // var screenWidth = this.getScreenWidth();
                // switch(true) {
                //     case (screenWidth < 768):
                //         coordinate.x = coordinate.x * .5;
                //         coordinate.y = coordinate.y * .5;
                //         break;
                //     case (screenWidth > 768 && screenWidth < 1200):
                //         coordinate.x = coordinate.x * .75;
                //         coordinate.y = coordinate.y * .75;
                //         break;
                // }
                $(floorId).append(this.moduleDotTemplate({
                    module: module,
                    moduleStatus: moduleStatus,
                    coordinate: coordinate,
                    colorStatus: colorStatus,
                    layout: layout
                }))

                this.setDraggable(floorId, module.get('module_id'));
                var item = $('#layout-module-item-' + module.get('module_id'))
                $('#floorLocation-' + $(item).data('module-id')).append('Floor: ' + _.escape(layout.get('name')))
            })
        })

        this.disableSelectedNodes();
        this.resizeHandler();

        $('.floor').first().removeAttr('hidden');
        $('#floor-title').text(this.currentFloor.get('name'));
    }

    disableSelectedNodes() {
        var moduleList = $('.layout-module-item')
        var me = this;
        _.each(moduleList, function (item) {
            if (_.find(me.renderedModuleIds, { module_id: $(item).data('module-id') })) {
                $(item).css({ 'background-color': '#F8F8F8', 'cursor': 'not-allowed', 'opacity': '.6' })
                $(item).data('added-module', true)
            }
        })
    }

    getScreenWidth(coordinate, container) {
        var containerH = ($(container).height() * coordinate.y) / coordinate.heightImg;
        var containerW = ($(container).width() * coordinate.x) / coordinate.widthImg;
        var moduleH = ($(container).height() * 20) / coordinate.heightImg;
        var moduleW = ($(container).width() * 20) / coordinate.widthImg;

        return { left: containerW, top: containerH, width: moduleW, height: moduleH };
    }

    buildPositionArray(svgFiles, currentFloor) {

        var dataArray = [];
        _.each(svgFiles, function (element) {
            $('#layout-drag-svg-modules-container-'+ element["dataset"].moduleLayoutid).removeAttr('hidden')
            var width = $('#wd-img-modules-container-'+ element["dataset"].moduleLayoutid).width();
            var height = $('#wd-img-modules-container-'+ element["dataset"].moduleLayoutid).height();
            if(currentFloor.get('id') != element["dataset"].moduleLayoutid){
                $('#layout-drag-svg-modules-container-'+ element["dataset"].moduleLayoutid).attr('hidden','')
            }
            var coordinate = {
                id: element["dataset"].moduleId,
                x: parseInt(element.style.left),
                y: parseInt(element.style.top),
                widthImg: width,
                heightImg: height
            };
            dataArray.push(coordinate);
        })

        return dataArray;
    }

    show() {
        this.render();
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/views/settings/InstallationLayoutView.ts